module.exports = __webpack_public_path__ + "media/images/Menu-outline-700e416f.svg";